import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Play } from 'lucide-react';
import Button from './ui/Button';
import { goToApp, IMAGES } from '../constants';

const CallToAction = ({ onOpenDemo }) => (
  <section className="relative overflow-hidden bg-[#07050d] text-white" data-testid="cta-section">
    <img src={IMAGES.cta} alt="" className="absolute inset-0 w-full h-full object-cover object-right opacity-80" />
    <div className="absolute inset-0 bg-gradient-to-r from-[#07050d] via-[#07050d]/80 to-transparent" />
    <div className="relative mx-auto max-w-7xl px-6 py-20 md:py-24 flex flex-col md:flex-row md:items-center gap-10">
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="flex-1">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-white/70 mb-3">Ready to create something amazing?</p>
        <h2 className="font-display text-3xl md:text-5xl font-extrabold tracking-tight">Your next great creative starts here.</h2>
        <p className="mt-3 text-white/75 text-base md:text-lg">Bring your idea. Build something worth sharing.</p>
        <Button size="lg" className="mt-8" onClick={goToApp} data-testid="cta-start-creating-btn">Start Creating Free <ArrowRight size={18} /></Button>
      </motion.div>
      <div className="flex items-center gap-10">
        <button onClick={onOpenDemo} className="group w-20 h-20 rounded-full bg-white/10 backdrop-blur border border-white/40 flex items-center justify-center hover:scale-110 transition-transform duration-300" aria-label="Watch demo" data-testid="cta-play-demo-btn">
          <Play className="ml-1 w-8 h-8 fill-white text-white" />
        </button>
        <p className="hidden lg:block font-script text-4xl leading-tight -rotate-6 text-white/90" aria-hidden>Create<br />&nbsp;Direct<br />&nbsp;&nbsp;Publish<br />&nbsp;&nbsp;&nbsp;Grow</p>
      </div>
    </div>
  </section>
);

export default CallToAction;
